import React from 'react'
import ReactDOM from 'react-dom'
import './index.css'
import App from './App'
import { initialState } from './context/initialState'
import { StateProvider } from './context/store'
import { mainReducer } from './context/reducers'

ReactDOM.render(
   <StateProvider initialState={initialState} reducer={mainReducer}>
      <App />
   </StateProvider>,
   document.getElementById('root')
)
